import { IStepProps } from '../../../pages/Sign-Up/UserDetailsForm';
import StepHeader from '../../../pages/Organization/public/Journal/SubmissionUpload/components/StepHeader';
import { Flex } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { scrollToError, StepTwoForm } from '../StepThree/signupHook';
import AddressOrAffiliation from './AddressOrAffiliation';
import { useCallback, useEffect, useRef, useState } from 'react';

const StepTwo = ({ currentStep, totalSteps, user }: IStepProps) => {
  const { reset, formState } = useFormContext<StepTwoForm>();

  const { errors, isSubmitted, submitCount } = formState;
  const lastScrolledSubmit = useRef<number | null>(null);
  const [openAllAccordions, setOpenAllAccordions] = useState(false);

  const scrollToFirstError = useCallback(() => {
    scrollToError(errors);
  }, [errors]);

  useEffect(() => {
    const hasErrors = Object.keys(errors || {}).length > 0;
    if (isSubmitted && hasErrors) {
      setOpenAllAccordions(true);

      if (lastScrolledSubmit.current !== submitCount) {
        lastScrolledSubmit.current = submitCount;

        setTimeout(() => {
          scrollToFirstError();
        }, 450);
      }
    }
  }, [errors, isSubmitted, submitCount, scrollToFirstError]);

  useEffect(() => {
    reset({
      additionalAffiliations: user?.additionalAffiliations,
      affiliationDetails: user?.affiliationDetails
    });
  }, [user]);

  return (
    <Flex direction={'column'} mb={10} px={6}>
      <StepHeader
        currentStep={currentStep}
        totalSteps={totalSteps}
        heading="Affiliations"
        description="Add your current or most recent affiliation. Verified affiliations boost trust and highlight your professional credibility."
      />
      <AddressOrAffiliation
        sectionTitle="Primary Affiliation"
        organizationId={user?.organizationId || ''}
        id="PrimaryAddress"
        user={user}
        forceOpen={openAllAccordions}
      />
      <AddressOrAffiliation
        sectionTitle="Secondary Affiliation(s)"
        organizationId={user?.organizationId || ''}
        isMultipleForm={true}
        id="SecondaryAddress"
        user={user}
        forceOpen={openAllAccordions}
      />
    </Flex>
  );
};

export default StepTwo;
